import { gql } from "@apollo/client";

export const LIST_TAB_CATEGORIES_AND_SUBCATEGORIES = gql`
query getCategoryDataForAssetCategoryType(
    $assetCategoryClassName: String!
)
  {
    getCategoryDataForAssetCategoryType(
        assetCategoryClassName: $assetCategoryClassName
    ) {
        categories{
            id,name
        },
        subCategories{
            id,name
        }
    }
  }
`;

export const LIST_TAB_MAKES = gql`
query getMakeData(
    $categoryId: String!
)
  {
    getMakeData(
        categoryId: $categoryId
    ) {
        make{
            id,name
        }
    }
  }
`;

export const LIST_TAB_MODELS = gql`
query getModelDataForGivenMakes(
    $makeIds: [String!]!
)
  {
    getModelDataForGivenMakes(
        makeIds: $makeIds
    ) {
        make{
            id,name
        },
        details{
        model{
            id,name
        },
        subModel{
            id,name    
        }
    }
    }
  }
`;
